module.exports = __webpack_public_path__ + "static/media/transparent-mobile-app.49f438bf.png";